'use strict';

import accordion from 'plugins/accordion';

const SELECTOR = '.js-accordion';
const NEXT_SELECTOR = '[data-accordion-next-selector]';

(function () {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return false;
    }

    elements.forEach(element => {
        accordion(element);
    });

    const nextSelectors = document.querySelectorAll(NEXT_SELECTOR);

    nextSelectors.forEach(selector => {
        selector.addEventListener('click', event => {
            const nextSelector = event
                .currentTarget
                .dataset
                .accordionNextSelector

            if (!nextSelector) {
                return;
            }

            const nextElement = document.querySelector(nextSelector);

            if (!nextElement) {
                return;
            }

            nextElement.click();
        }, false);
    });

}());
